import type { PWAUpdatePolicy } from './pwa-update-policy'

export type DevTestPolicyOverrides = Pick<Partial<PWAUpdatePolicy>, 'snoozeMinutes' | 'deadlineMinutes'>

export const formatClock = (ms: number) => {
  const seconds = Math.max(0, Math.ceil(ms / 1000))
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`
}

export const formatCountdownBadge = (ms: number) => {
  if (ms < 60 * 1000) return `${Math.max(0, Math.ceil(ms / 1000))}s`
  return `${Math.ceil(ms / 60000)}m`
}

const getPositiveQueryNumber = (params: URLSearchParams, key: string): number | undefined => {
  const value = Number(params.get(key))
  return Number.isFinite(value) && value > 0 ? value : undefined
}

export const getDevTestPolicyOverrides = (params: URLSearchParams, snoozeMinutesParam: string, deadlineMinutesParam: string): DevTestPolicyOverrides => {
  const snoozeMinutes = getPositiveQueryNumber(params, snoozeMinutesParam)
  const deadlineMinutes = getPositiveQueryNumber(params, deadlineMinutesParam)

  return {
    ...(snoozeMinutes ? { snoozeMinutes } : {}),
    ...(deadlineMinutes ? { deadlineMinutes } : {}),
  }
}
